var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPersonGear = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 18v-.65a.946.946 0 01.41-.81A10.889 10.889 0 0110 15a.22.22 0 01.08.01 6.886 6.886 0 01.59-1.98c-.22-.02-.44-.03-.67-.03a12.876 12.876 0 00-6.61 1.82A2.922 2.922 0 002 17.35V20h9.26a7.133 7.133 0 01-.97-2zM10 12a4 4 0 10-4-4 4 4 0 004 4zm0-6a2 2 0 11-2 2 2.006 2.006 0 012-2zM20.75 16a4.338 4.338 0 00-.06-.63l1.14-1.01-1-1.73-1.45.49a3.647 3.647 0 00-1.08-.63L18 11h-2l-.3 1.49a3.647 3.647 0 00-1.08.63l-1.45-.49-1 1.73 1.14 1.01a4.338 4.338 0 00-.06.63 4.338 4.338 0 00.06.63l-1.14 1.01 1 1.73 1.45-.49a3.647 3.647 0 001.08.63L16 21h2l.3-1.49a3.647 3.647 0 001.08-.63l1.45.49 1-1.73-1.14-1.01a4.338 4.338 0 00.06-.63zM17 18a2 2 0 112-2 2.006 2.006 0 01-2 2z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPersonGear);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/person_gear.abbad91f40409b017aad0236ad58cff1.svg";